import SilRoomsContainer from "./SilRooms.container";

export default SilRoomsContainer;
